export default __webpack_public_path__ + "static/media/upgrade.d2db27a2.png";